import styled from 'styled-components';
import Image from '@stencil/image';

// COMPONENTS
import {Column as FlexColumn} from '../../../../../../stories/components/hotels/common/Layouts/Layouts';

export const Column = styled(FlexColumn)(
  props => `

    width: 100%;
    border-bottom: 0.8rem solid ${props.theme.colors.downriver.light};
    &:last-child {
      border-bottom: none;
    }
`,
);

export const RoomContainer = styled.div(
  props => `
  display: flex;
  background-color: ${props.theme.colors.goWhite.base};
  border-bottom: 0.8rem solid ${props.theme.colors.goBrandBlue.light};
  &:last-child {
    border-bottom: none;
    border-bottom-left-radius: ${props.theme.misc.borderRadius.xxxlarge};
    border-bottom-right-radius: ${props.theme.misc.borderRadius.xxxlarge};
  }
`,
);

export const RoomTypeStyledWrapper = styled.div(
  props => `
  padding: 2.4rem;
  padding-top:0;
  border-right: 0.1rem solid ${props.theme.colors.goBrandBlue.light};
  width: ${props.width || '40%'};
`,
);

export const RoomTypeTextStyled = styled.h3(
  props => `
  font-size: ${props.theme.font.custom(14)};
  padding-top: 2rem;
  padding-bottom: ${props.theme.spacing.base};
  font-weight: 600;
  background:white;
  position:sticky;
  top:calc(21rem + ${props.filterHeight}px);
  word-break: break-word;
  z-index:99;
`,
);

export const RoomTypeStickyWrap = styled.div(
  props => `
  position:sticky;
  top:calc(21.8rem + ${props.filterHeight}px);
`,
);

export const RoomImageWrapper = styled(Column)(
  props => `
  padding-top: ${props.theme.spacing.base};
  padding-bottom: ${props.theme.spacing.base};
  position:relative;
`,
);

export const RoomImageStyled = styled(Image)(
  props => `
  display: flex;
  height:23rem;
  width: 100%;
  object-fit: fill;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
`,
);

export const RoomTypeColumnIconsContainer = styled.div(props => {
  const defaultPadding = `0 ${props.theme.spacing.base} 0 0`;

  return `
    padding: ${props.padding ? props.padding : defaultPadding};
    margin-top:${props.marginTop || ''};
  `;
});

export const LeftDiv = styled.div(
  props => `
  display:flex;
  width:100%;
  `,
);

export const RoomFeaturesWrapper = styled.div(
  props => `
    display: flex;
    flex-wrap: wrap;
    gap: 0 1rem;
  `,
);

export const RoomImageTag = styled.div(
  props => `
  position: absolute;
  bottom: 1.6rem;
  left: .8rem;
  border-radius: ${props.theme.misc.borderRadius.large};
  background: ${props.theme.colors.downriver.base};
  box-shadow: 0px .4rem .5rem rgba(0, 0, 0, 0.3);
  color: ${props.theme.colors.goWhite.base};
  font-weight: 600;
  font-size: ${props.theme.font.custom(14)};
  padding: ${props.theme.spacing.custom(8)} ${props.theme.spacing.custom(
    24,
  )} ${props.theme.spacing.custom(8)} ${props.theme.spacing.custom(8)};
  &:after{
    border: solid #fff;
    border-width: 0 0.2rem 0.2rem 0;
    display: inline-block;
    padding: 0.3rem;
    transform: rotate(-45deg);
    position: absolute;
    right: 1rem;
    top: 1.4rem;
    content: "";
  }
  `,
);

export const ExtraBed_OuterWrapperDiv = styled.div(
  props => `
  margin: ${props.theme.spacing.base} 0 0 0;
  `,
);

export const RoomInfoReview = styled.div(
  props => `
  // width: 29rem;
  max-width:36rem;
  position: relative;
  background: ${props.theme.colors.ash.light};
  color: ${props.theme.colors.downriver.dark};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  padding:${props.theme.spacing.custom(12)};
  margin-top:15px;
  cursor:pointer;
  `,
);

export const SingleQuoteWrap = styled.p(
  props => `
  position: absolute;
  right: 15px;
  bottom: 0px;
  `,
);

export const TopRatedImg = styled(Image)(
  props => `
      width: 5.4rem;
      height: 5.4rem;
      margin-right: ${props.theme.spacing.custom(12)};
      `,
);

export const ReviewContent = styled.p(
  props => `
  font-size: 14px;
  margin-bottom:10px;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  `,
);

export const RoomWithJacuzziCardWrapper = styled.div(
  props =>
    `
  padding: 5px;
  background-color: ${props.theme.colors.goTeal.light};
  width: auto;
  margin: 15px 0px 23px 0px;
  border-radius: 6px;
  display: flex;
  align-items: flex-start;
  svg{
    flex-shrink:0;
  }
    span {
      color: ${props.theme.colors.goTeal.dark};
      margin-left: 6px;
      font-size: 14px;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  `,
);

export const BedTypeTNCStyled = styled.p(
  props => `
  font-size: ${props.theme.font.custom(12)};
  padding-top: 2rem;
  padding-bottom: ${props.theme.spacing.base};
  background:white;
  top:calc(21rem + ${props.filterHeight}px);
  word-break: break-word;
  z-index:99;
  color: #606060;
  min-width: 50%;
`,
);
